import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";

const config = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

export const GET_TRACKING_INFO = "httpsOnCallGetTrackingDataByTrackingNumber";
export const CREATE_SHIPPING_EXP =
  "httpsOnCallCreateCustomerShippingExperience";

export const app = initializeApp(config);
export const functions = getFunctions(app);
